import React, { PureComponent } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'

interface Props {
  src: string
}

class PDFViewer extends PureComponent<Props> {
  state = {
    numPages: 0,
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages })
  }

  render() {
    const { src } = this.props
    return (
      <Document file={src} onLoadSuccess={this.onDocumentLoadSuccess}>
        {Array(this.state.numPages)
          .fill(0)
          .map((_, idx) => <Page key={`p${idx}`} pageNumber={idx + 1} />)}
      </Document>
    )
  }
}

export default PDFViewer
